import { useCallback, useEffect, useRef, useState, type ReactNode } from "react";
import { registrarPedidoDePin, type ModoDoPin } from "@/lib/pin-link";
import { PinDialog } from "./PinDialog";

/**
 * Dono do diálogo de PIN. Registra no `pinLink` uma função que abre o diálogo e devolve, por
 * promessa, se o PIN foi confirmado (ou criado) — e aí o link repete a ação que pediu.
 */
export function PinProvider({ children }: { children: ReactNode }) {
  const [modo, setModo] = useState<ModoDoPin | null>(null);
  const resolver = useRef<((ok: boolean) => void) | null>(null);

  const pedir = useCallback(
    (m: ModoDoPin) =>
      new Promise<boolean>((resolve) => {
        resolver.current?.(false);
        resolver.current = resolve;
        setModo(m);
      }),
    [],
  );

  useEffect(() => {
    registrarPedidoDePin(pedir);
    return () => registrarPedidoDePin(null);
  }, [pedir]);

  const fechar = (ok: boolean) => {
    resolver.current?.(ok);
    resolver.current = null;
    setModo(null);
  };

  return (
    <>
      {children}
      <PinDialog modo={modo} onFechar={fechar} />
    </>
  );
}
